<template>
  <div v-if="contact" class="space-y-6">
    <div class="border rounded bg-white overflow-hidden">
      <nav class="flex-none z-0 flex divide-x divide-gray-200">
        <button
          v-for="tab in tabs"
          :key="tab.name"
          :class="[
            currentTab.name === tab.name ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700',
            'group relative min-w-0 flex-1 bg-white py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10',
          ]"
          @click="setCurrentTab(tab)"
        >
          <span>{{ tab.displayName }}</span>
          <span
            :class="[
              currentTab.name === tab.name ? 'bg-blue-500' : 'bg-transparent',
              'absolute inset-x-0 bottom-0 h-0.5',
            ]"
          />
          <span
            v-if="tab.countAttribute in contact"
            :class="[
              currentTab.name === tab.name
                ? 'bg-blue-100 text-blue-600'
                : 'bg-gray-100 text-gray-900',
              'hidden ml-3 py-0.5 px-2.5 rounded-full text-xs font-medium md:inline-block',
            ]"
            >{{ contact[tab.countAttribute] }}</span
          >
        </button>
      </nav>
    </div>
    <div>
      <component
        v-if="currentTab"
        :is="currentTab.component"
        :contact-id="contactId"
        :contact="contact"
      />
    </div>
  </div>
</template>

<script>
import { contactsClient } from '@/api/clients/index';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      currentTab: null,
      contact: null,
    };
  },
  computed: {
    tabs() {
      return [
        {
          name: 'email-messages-tab',
          displayName: 'Emails',
          component: () => import('../emailMessagesTab/EmailMessagesTab.vue'),
          countAttribute: 'email_messages_count',
          show: () =>
            this.$membershipHasPermissionTo('read email messages') || this.$isAdminOrSuperAdmin,
        },
        {
          name: 'sms-messages-tab',
          displayName: 'Sms Messages',
          component: () => import('../smsMessagesTab/SmsMessagesTab.vue'),
          countAttribute: 'sms_messages_count',
          show: () =>
            this.$membershipHasPermissionTo('read sms messages') || this.$isAdminOrSuperAdmin,
        },
      ].filter((item) => item.show());
    },
  },
  created() {
    this.currentTab = this.tabs[0];
    this.loadContact();
  },
  methods: {
    async loadContact() {
      try {
        const response = await contactsClient.read(this.contactId, {
          include: [
            'primaryEmailAddress',
            'emailAddresses',
            'primaryPhoneNumber',
            'phoneNumbers',
            'emailMessagesCount',
            'smsMessagesCount',
          ],
        });

        this.contact = response.data;
      } catch (error) {
        //
      }
    },
    setCurrentTab(tab) {
      if (this.currentTab?.name === tab?.name) {
        return;
      }

      this.currentTab = tab;
    },
  },
};
</script>
